import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { Button } from '@/components/ui';

interface SourcesMenuFooterProps {
    onAddSources: () => void;
    submitLabel?: string;
    disabled?: boolean;
}

export function SourcesMenuFooter({
    onAddSources,
    submitLabel,
    disabled,
}: SourcesMenuFooterProps) {
    const { t } = useTranslation(I18nNamespace.SOURCES);
    const label = submitLabel ?? t('menu.addSources');
    return (
        <div className="flex shrink-0 justify-end">
            <Button
                variant="secondary"
                onClick={onAddSources}
                disabled={disabled}
            >
                {label}
            </Button>
        </div>
    );
}
